(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Read current variant availability rendered by Liquid; no manually maintained stock tags.
  if (!customElements.get('sabeti-size-filter')) {
    class SabetiSizeFilter extends HTMLElement {
      get select() { return this.querySelector('select'); }
      connectedCallback() {
        this.root = this.closest('results-list');
        this.onChange = () => {
          const next = new URL(window.location.href);
          if (this.select.value) next.searchParams.set('sabeti_size', this.select.value);
          else next.searchParams.delete('sabeti_size');
          next.searchParams.delete('page');
          history.replaceState(null, '', next);
          this.apply();
        };
        this.onReset = event => { if (event.target.closest('[data-size-reset]')) { this.select.value = ''; this.onChange(); } };
        this.onPopState = () => this.restore();
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onReset);
        window.addEventListener('popstate', this.onPopState);
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !this.contains(node)))) this.restore();
        });
        this.observer.observe(this.root, {childList: true, subtree: true});
        this.hidden = false;
        this.restore();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onReset);
        window.removeEventListener('popstate', this.onPopState);
        this.observer.disconnect();
      }
      restore() {
        const value = new URL(window.location.href).searchParams.get('sabeti_size') || '';
        this.select.value = [...this.select.options].some(option => option.value === value) ? value : '';
        this.apply();
      }
      apply() {
        const size = this.select.value;
        const cards = [...this.root.querySelectorAll('[data-available-sizes]')];
        let count = 0;
        for (const card of cards) {
          card.hidden = Boolean(size && !card.dataset.availableSizes.split('|').includes(size));
          if (!card.hidden) count++;
          // A size-specific shopping link lands on that purchasable variant.
          for (const link of card.querySelectorAll('a[href*="/products/"]')) {
            if (!link.dataset.sizeBaseUrl) link.dataset.sizeBaseUrl = link.getAttribute('href');
            const href = new URL(link.dataset.sizeBaseUrl, window.location.origin);
            const variant = card.querySelector('script[data-size-variants]');
            const ids = variant ? JSON.parse(variant.textContent) : {};
            if (size && ids[size]) href.searchParams.set('variant', ids[size]);
            link.setAttribute('href', size ? href.pathname + href.search : link.dataset.sizeBaseUrl);
          }
        }
        const countNode = this.querySelector('[data-size-count]');
        countNode.textContent = countNode.dataset.countTemplate.replace('__COUNT__', String(count));
        this.querySelector('[data-size-empty]').hidden = count > 0;
        for (const node of this.root.querySelectorAll('[title="Product count"]')) {
          if (!node.dataset.sizeOriginalCount) node.dataset.sizeOriginalCount = node.textContent;
          node.textContent = size ? countNode.textContent : node.dataset.sizeOriginalCount;
        }
        this.root.toggleAttribute('data-size-filter-active', Boolean(size));
      }
    }
    customElements.define('sabeti-size-filter', SabetiSizeFilter);
  }


  } catch(e) { console.error(e); }
})();
})();
